module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a5-1-c6c7a28ef977434f1a8c43179c5dc033.jpg";